export const getAction = (key) => {
    switch(key) {
        case "mention.staff":
            return window.i18n.__("vous a mentionné sur");
        default:
            return ''
    }
}